// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JmI_8","content":"styles_content__1ADb4","row":"styles_row__ykxmB","footer":"styles_footer__QCLuv","phraseLength":"styles_phraseLength__3sUbd"};